angular.module('picmonicng').filter('stringMatch', function () {
  return function (haystack, needle) {
    var needle = needle
      .replace(/'s+/gi, '')
      .replace(/[']+/gi, '')
      .replace(/[^a-z0-9]+/gi, ' ')
      .split(' ');

    // See Service_Card::byFact when updating additional words
    var exclude = [
      'a',
      'abnormal',
      'about',
      'above',
      'across',
      'action',
      'active',
      'activity',
      'acute',
      'administration',
      'affected',
      'after',
      'again',
      'against',
      'all',
      'almost',
      'alone',
      'along',
      'already',
      'also',
      'although',
      'always',
      'among',
      'an',
      'anatomy',
      'and',
      'another',
      'anterior',
      'antidote',
      'any',
      'anybody',
      'anyone',
      'anything',
      'anywhere',
      'appearance',
      'are',
      'area',
      'areas',
      'around',
      'as',
      'ask',
      'asked',
      'asking',
      'asks',
      'assess',
      'assessment',
      'associations',
      'at',
      'avoid',
      'away',
      'b',
      'back',
      'backed',
      'backing',
      'backs',
      'be',
      'became',
      'because',
      'become',
      'becomes',
      'been',
      'before',
      'began',
      'behind',
      'being',
      'beings',
      'best',
      'better',
      'between',
      'big',
      'binds',
      'binds',
      'block',
      'blockers',
      'blocks',
      'both',
      'but',
      'by',
      'c',
      'came',
      'can',
      'cannot',
      'care',
      'case',
      'cases',
      'cause',
      'cause',
      'caused',
      'causes',
      'certain',
      'certainly',
      'change',
      'change',
      'changes',
      'characteristics',
      'chronic',
      'clear',
      'clearly',
      'clinical features',
      'close',
      'closed',
      'closes',
      'come',
      'common',
      'common',
      'complete',
      'complex',
      'complications',
      'considerations',
      'contact',
      'continued',
      'control',
      'could',
      'criteria',
      'd',
      'decrease',
      'decreased',
      'decreases',
      'deep',
      'defective',
      'deficiency',
      'delayed',
      'development',
      'diagnosis',
      'did',
      'differ',
      'different',
      'differently',
      'direct',
      'disease',
      'diseases',
      'disorder',
      'disorders',
      'do',
      'does',
      'done',
      'down',
      'down',
      'downed',
      'downing',
      'downs',
      'drug',
      'drugs',
      'drugs and complications',
      'dry',
      'due',
      'during',
      'dysfunction',
      'e',
      'each',
      'early',
      'education',
      'effects',
      'either',
      'elevate',
      'elevated',
      'end',
      'ended',
      'ending',
      'ends',
      'enough',
      'evaluation',
      'even',
      'evenly',
      'ever',
      'every',
      'everybody',
      'everyone',
      'everything',
      'everywhere',
      'excessive',
      'exposure',
      'f',
      'face',
      'faces',
      'fact',
      'factors',
      'facts',
      'far',
      'features',
      'felt',
      'few',
      'find',
      'finds',
      'first',
      'for',
      'free',
      'from',
      'full',
      'fully',
      'further',
      'furthered',
      'furthering',
      'furthers',
      'g',
      'gave',
      'general',
      'generally',
      'get',
      'gets',
      'give',
      'given',
      'gives',
      'go',
      'going',
      'good',
      'goods',
      'got',
      'great',
      'greater',
      'greatest',
      'group',
      'grouped',
      'grouping',
      'groups',
      'h',
      'had',
      'has',
      'have',
      'having',
      'he',
      'her',
      'here',
      'herself',
      'high',
      'high',
      'high',
      'higher',
      'highest',
      'him',
      'himself',
      'his',
      'how',
      'however',
      'i',
      'if',
      'impaired',
      'implementation',
      'implementations',
      'important',
      'in',
      'increase',
      'increased',
      'increases',
      'indication',
      'indications',
      'inhibit',
      'inhibition',
      'inhibitor',
      'inhibitors',
      'inhibits',
      'interest',
      'interested',
      'interesting',
      'interests',
      'internal',
      'interpretation',
      'interventions',
      'into',
      'intoxication',
      'is',
      'it',
      'its',
      'itself',
      'j',
      'just',
      'k',
      'keep',
      'keeps',
      'kind',
      'knew',
      'know',
      'known',
      'knows',
      'l',
      'lab',
      'lab value',
      'lab values',
      'labs',
      'lack',
      'land',
      'large',
      'largely',
      'last',
      'late',
      'later',
      'latest',
      'least',
      'left',
      'less',
      'let',
      'lets',
      'light',
      'like',
      'likely',
      'limit',
      'long',
      'longer',
      'longest',
      'loss',
      'low',
      'lower',
      'm',
      'made',
      'maintain',
      'major',
      'make',
      'making',
      'man',
      'management',
      'many',
      'may',
      'me',
      'mechanism',
      'mechanisms',
      'medial',
      'medication',
      'medications',
      'member',
      'members',
      'men',
      'meq',
      'middle',
      'might',
      'monitor',
      'monitoring',
      'more',
      'most',
      'mostly',
      'mr',
      'mrs',
      'much',
      'multiple',
      'must',
      'my',
      'myself',
      'n',
      'necessary',
      'need',
      'needed',
      'needing',
      'needs',
      'negative',
      'negative',
      'never',
      'new',
      'new',
      'newer',
      'newest',
      'next',
      'no',
      'nobody',
      'non',
      'none',
      'not',
      'nothing',
      'now',
      'nowhere',
      'number',
      'numbers',
      'o',
      'occurs',
      'of',
      'off',
      'often',
      'old',
      'older',
      'oldest',
      'on',
      'once',
      'one',
      'only',
      'onset',
      'open',
      'opened',
      'opening',
      'opens',
      'or',
      'oral',
      'order',
      'ordered',
      'ordering',
      'orders',
      'other',
      'others',
      'our',
      'out',
      'over',
      'overview',
      'p',
      'part',
      'parted',
      'partial',
      'parting',
      'parts',
      'pathway',
      'pathways',
      'peak',
      'per',
      'perhaps',
      'physical',
      'place',
      'places',
      'point',
      'pointed',
      'pointing',
      'points',
      'poisoning',
      'positive',
      'positive',
      'possible',
      'posterior',
      'potential',
      'precautions',
      'present',
      'presented',
      'presenting',
      'presents',
      'prevent',
      'prevention',
      'primary',
      'problem',
      'problems',
      'procedure',
      'produces',
      'products',
      'prophylaxis',
      'put',
      'puts',
      'q',
      'quite',
      'r',
      'rapid',
      'rather',
      'really',
      'receptor',
      'reduce',
      'remove',
      'right',
      'right',
      'risk',
      'risk',
      'room',
      'rooms',
      's',
      'said',
      'same',
      'saw',
      'say',
      'screening',
      'seconds',
      'see',
      'seem',
      'seemed',
      'seeming',
      'seems',
      'sees',
      'selective',
      'several',
      'severe',
      'shall',
      'shaped',
      'she',
      'should',
      'show',
      'showed',
      'showing',
      'shows',
      'side',
      'side effects',
      'sides',
      'signs',
      'signs & symptoms',
      'signs/symptoms',
      'since',
      'slow',
      'small',
      'smaller',
      'smallest',
      'so',
      'soft',
      'some',
      'somebody',
      'someone',
      'something',
      'somewhere',
      'stage',
      'stages',
      'still',
      'still',
      'stimulates',
      'such',
      'suffix',
      'support',
      'sure',
      'surgical',
      'symptoms',
      'syndrome',
      'system',
      'systemic',
      't',
      'take',
      'taken',
      'term',
      'test',
      'tests',
      'than',
      'that',
      'the',
      'their',
      'them',
      'then',
      'theory',
      'therapy',
      'there',
      'therefore',
      'these',
      'they',
      'thing',
      'things',
      'think',
      'thinks',
      'this',
      'those',
      'though',
      'thought',
      'thoughts',
      'through',
      'thus',
      'to',
      'today',
      'together',
      'too',
      'took',
      'toward',
      'toxicities',
      'toxicity',
      'treat',
      'treatment',
      'treatments',
      'turn',
      'turned',
      'turning',
      'turns',
      'type',
      'types',
      'u',
      'unable',
      'under',
      'until',
      'up',
      'upon',
      'upper',
      'us',
      'use',
      'use',
      'used',
      'uses',
      'uses',
      'v',
      'value',
      'variable',
      'variable',
      'very',
      'virus',
      'w',
      'wall',
      'want',
      'wanted',
      'wanting',
      'wants',
      'was',
      'way',
      'ways',
      'we',
      'well',
      'wells',
      'went',
      'were',
      'what',
      'when',
      'where',
      'whether',
      'which',
      'while',
      'who',
      'whole',
      'whose',
      'why',
      'will',
      'with',
      'within',
      'without',
      'work',
      'worked',
      'working',
      'works',
      'would',
      'x',
      'y',
      'yet',
      'you',
      'young',
      'younger',
      'youngest',
      'your',
      'yours',
      'z',
    ];

    for (b in needle) {
      if (exclude.indexOf(needle[b]) == -1) {
        var index = haystack.toLowerCase().indexOf(needle[b].toLowerCase());
        if (index > -1) {
          haystack =
            haystack.slice(0, index) +
            '<span class="pls-orange">' +
            haystack.slice(index, index + needle[b].length) +
            '</span>' +
            haystack.slice(index + needle[b].length);
        }
      }
    }

    return haystack;
  };
});
